module.exports = require('./helpers/bundle-url').getBundleURL('lly8x') + "usersdash.517f461c.png" + "?" + Date.now();